import React, { useState, useEffect } from 'react';
import ComanServices from '../../services/ComanServices';

function AboutUs() {
  const [formData, setFormData] = useState({
    Name: '',
    qulafication: '',
    occupation: '',
    experience: '',
    website: '',
    experties: '',
    file: null, // For file upload
  });
  const [previewImage, setPreviewImage] = useState('img/placeholder-img.png'); 
  
  // Fetch existing data using the GET API
  useEffect(() => {
    ComanServices.getAbout()
      .then(response => {
        console.log(response);
        const data = response.data;
        setFormData({
          Name: data?.Name,
          qulafication: data?.qulafication,
          occupation: data?.occupation,
          experience: data?.experience,
          website: data?.website,
          experties: data?.experties,
          file: null, // Assuming the file will be uploaded manually
        });
        if (data.image) {
          setPreviewImage(process.env.REACT_APP_URL + data.image);
        }
      })
      .catch(error => {
        console.error("There was an error fetching the about us data!", error);
      });
  }, []);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  // Handle file changes and update the preview
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result); // Set the preview image
      };
      reader.readAsDataURL(file);
      
      // Update the formData with the file
      setFormData(prevState => ({
        ...prevState,
        file: file
      }));
    }
  };

  // Handle form submission for update
  const handleSubmit = (e) => {
    e.preventDefault();

    // Create form data to include file upload
    const formDataToSend = new FormData();
    formDataToSend.append('Name', formData.Name);
    formDataToSend.append('qulafication', formData.qulafication);
    formDataToSend.append('occupation', formData.occupation);
    formDataToSend.append('experience', formData.experience);
    formDataToSend.append('website', formData.website);
    formDataToSend.append('experties', formData.experties);
    if (formData.file) {
      formDataToSend.append('image', formData.file);
    }

    // Send data to update API
    ComanServices.updateAbout(formDataToSend)
      .then(response => {
        alert("Data updated successfully!", response);
      })
      .catch(error => {
        console.error("There was an error updating the data!", error);
      });
  };

  return (
    <div className="right_col" role="main">
      <div className="title-box">
        <h2>About us</h2>
      </div>
      <div className="container-box px-5">
        <div className="page-details">
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-6">
                <div className="input-field">
                  <label>Name</label>
                  <input
                    type="text"
                    name="Name"
                    value={formData.Name}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="input-field">
                  <label>Qualification</label>
                  <input
                    type="text"
                    name="qulafication"
                    value={formData.qulafication}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="input-field">
                  <label>Occupation</label>
                  <input
                    type="text"
                    name="occupation"
                    value={formData.occupation}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="input-field">
                  <label>Experience</label>
                  <input
                    type="text"
                    name="experience"
                    value={formData.experience}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="input-field">
                  <label>Website</label>
                  <input
                    type="text"
                    name="website"
                    value={formData.website}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="input-field">
                  <label>Expertise</label>
                  <input
                    type="text"
                    name="experties"
                    value={formData.experties}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>
              </div>
              <div className="col-md-12">
                <div className="input-field">
                  <label>Upload<span className="red">*</span></label>
                  <input
                    type="file"
                    name="file"
                    className="form-control"
                    onChange={handleFileChange} // Use handleFileChange here
                  />
                  <p><span>Drop an image or Paste URL (upto resolution 1,500 x 1,500 px),</span> Supported formats: png, jpeg, jpg, webp</p>
                  <div className="file-preview text-center">
                    <img id="uploadFile" src={previewImage} alt="your image" />
                  </div>   
                </div>
              </div>
            </div>
            <button type="submit" className="submit-green-btn">SUBMIT</button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default AboutUs;
